import React, {useContext} from 'react'
import { observer } from 'mobx-react-lite'
import {Store} from "../../../app/stores/store-root";

const AccountSummary = () => {
  const store = useContext(Store);
  const {Summary}=store.Orders
    return (
      <div >
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Your Orders Summary
        </h3>
        <div className="mt-5 grid grid-cols-1 rounded-lg bg-gray-200 overflow-hidden shadow md:grid-cols-5">
          <div>
            <div className="px-4 py-5 sm:p-6 ">
              <dl>
                <dt className="text-lg leading-6 font-semibold text-gray-900">
                  Balance Used
                </dt>
                <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {Summary?.CurrencySymbol}{Summary?.Used}
                    <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                      from {Summary?.Limit} limit
                    </span>
                  </div>
                  {/* <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    <svg className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span className="sr-only">
                      Increased by
                    </span>
                    12%
                  </div> */}
                </dd>
              </dl>
            </div>
          </div>
          <div className="border-t border-solid border-gray-100 md:border-0 md:border-l-2">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-lg leading-6 font-semibold text-gray-900">
                  Total Paid
                </dt>
                <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {Summary?.CurrencySymbol}{Summary?.TotalPaid}
                    <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                      from {Summary?.CountOfPaid} orders
                    </span>
                  </div>
                  {/* <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    <svg className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span className="sr-only">
                      Increased by
                    </span>
                    2.02%
                  </div> */}
                </dd>
              </dl>
            </div>
          </div>
          <div className="border-t  border-solid border-gray-100  md:border-0 md:border-l-2">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-lg leading-6 font-semibold text-gray-900">
                    Pending Approval
                </dt>
                <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {Summary?.CurrencySymbol}{Summary?.TotalPendingApproval}
                    <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                      from {Summary?.CountOfPendingApproval} orders
                    </span>
                  </div>
                  {/* <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                    <svg className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span className="sr-only">
                      Decreased by
                    </span>
                    4.05%
                  </div> */}
                </dd>
              </dl>
            </div>
          </div>
          <div className="border-t  border-solid border-gray-100  md:border-0 md:border-l-2">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-lg leading-6 font-semibold text-gray-900">
                  Ready for Collection
                </dt>
                <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {Summary?.CurrencySymbol}{Summary?.TotalReadyForCollection}
                    <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                      from {Summary?.CountOfReadyForCollection} orders
                    </span>
                  </div>
                  {/* <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    <svg className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span className="sr-only">
                      Increased by
                    </span>
                    2.02%
                  </div> */}
                </dd>
              </dl>
            </div>
          </div>
          <div className="border-t  border-solid border-gray-100 md:border-0 md:border-l-2">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-lg leading-6 font-semibold text-gray-900">
                  Grand Total
                </dt>
                <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                  <div className="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                    {Summary?.CurrencySymbol}{Summary?.GrandTotalAmount}
                    <span className="ml-2 text-sm leading-5 font-medium text-gray-500">
                      from {Summary?.GrandTotalCount} orders
                    </span>
                  </div>
                  {/* <div className="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    <svg className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span className="sr-only">
                      Increased by
                    </span>
                    2.02%
                  </div> */}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      

    )
}

export default observer(AccountSummary);